export default __webpack_public_path__ + "static/plan_calc-700fffae44fde4295a5064042a548f54.jpg";